import "../../CommonImports";
import "../../Core/core.css";
import "./Tabs.css";
import * as React from "react";
import { Observer } from '../../Observer';
export const TabGroupProviderContext = React.createContext({ groups: [] });
export class TabGroupProvider extends React.Component {
    render() {
        return (React.createElement(Observer, { groups: this.props.providers }, (props) => {
            const groups = props.groups.sort((a, b) => (a.order || 100) - (b.order || 100));
            return React.createElement(TabGroupProviderContext.Provider, { value: { groups } }, this.props.children);
        }));
    }
}
